import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v1/stock/tradelimit/';
}

/**
 * @param {string} url
 * @returns
 */
function callbackFetch(url) {
  return async () => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url);

      return res.data?.result;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
